import _ from "lodash";

export const getPlatform = () => {
  const { platform } = navigator;
  if (platform.indexOf("Mac") > -1) return "Mac";
  if (platform.indexOf("Win") > -1) return "Windows";
  return undefined;
};

export const isModifiersEqual = (aModifiers, bModifiers) => {
  if (!aModifiers || !bModifiers) return true;
  if (aModifiers.length !== bModifiers.length) return false;
  return aModifiers.every((aModifier) => {
    const bModifier = bModifiers.find((m) => m.modifier_group_id === aModifier.modifier_group_id);
    if (!bModifier) return false;
    return aModifier.value.map((i) => i.id).sort((a, b) => a - b).join()
      === bModifier.value.map((i) => i.id).sort((a, b) => a - b).join();
  });
};

export const stringifyModifiers = (items) => {
  const grouped = _.groupBy(items.map((i) => i.list_name));
  return Object.keys(grouped)
    .map((name) => {
      const count = grouped[name].length;
      return count > 1 ? `${name}\u00A0(x${count})` : name;
    })
    .join(", ");
};

export const doubleFetch = (query) => query.fetch()
  .catch((err) => {
    // Temporary workaround (watermelon bug?)
    // watermelon does not immediately cache order lines when new order came from server
    // we have to manually fetch them
    if (err.message.includes("was sent over the bridge, but it's not cache")) {
      return query.fetch();
    }
    return Promise.reject(err);
  });
